import { render } from "./ViewMediaMoreRadio.vue?vue&type=template&id=7974977f&scoped=true"
import script from "./ViewMediaMoreRadio.vue?vue&type=script&lang=js"
export * from "./ViewMediaMoreRadio.vue?vue&type=script&lang=js"

import "./ViewMediaMoreRadio.vue?vue&type=style&index=0&id=7974977f&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-7974977f"

export default script